// routes
// import { PATH_DASHBOARD } from '../../../routes/paths';
// components
// import Label from '../../../components/label';
// import Iconify from '../../../components/iconify';
import { WebRoutes } from 'consts/enpoints/web';
import routes from 'consts/routes';
import SvgColor from 'lib/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    // subheader: 'general',
    subheader: '',
    items: [
      {
        ...routes[WebRoutes.Dashboard],
        title: 'dashboard',
        // roles: [
        //   RoleName.Admin,
        //   RoleName.RootAdmin,
        //   RoleName.Employee,
        // ],
        // path: WebRoutes.Dashboard,
        icon: ICONS.dashboard,
        children: null
      },
      {
        ...routes[WebRoutes.Transactions],
        title: 'transactions',
        // roles: [
        //   RoleName.Admin,
        //   RoleName.RootAdmin,
        //   RoleName.Employee,
        // ],
        // path: WebRoutes.Transactions,
        icon: ICONS.analytics,
        children: null
      },
      {
        ...routes[WebRoutes.TransactionList],
        title: 'transaction list',
        // roles: [RoleName.Mors],
        // path: WebRoutes.TransactionList,
        icon: ICONS.analytics,
        children: null
      },
      {
        ...routes[WebRoutes.Merchants.Index],
        title: 'merchants',
        // roles: [
        //   RoleName.Admin,
        //   RoleName.RootAdmin,
        //   RoleName.Employee,
        // ],
        // path: WebRoutes.Merchants.Index,
        icon: ICONS.cart,
        children: [
          {
            ...routes[WebRoutes.Merchants.List],
            title: 'General',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin,
            //   RoleName.Employee,
            // ],
            // path: WebRoutes.Merchants.List
          },
          {
            ...routes[WebRoutes.Merchants.TicketingSystem.Index],
            title: 'Ticketing System',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.Merchants.TicketingSystem.Index
          },
        ]
      },
      {
        ...routes[WebRoutes.KYCSettings.Index],
        title: 'KYC Settings',
        icon: ICONS.lock,
        children: [
          {
            ...routes[WebRoutes.KYCSettings.MerchantKYCSettings.Index],
            title: 'Merchant KYC Settings',
          },
          {
            ...routes[WebRoutes.KYCSettings.PSPKYCSettings.Index],
            title: 'PSP KYC Settings',
          }
        ]
      },
      {
        ...routes[WebRoutes.MerchantPayouts],
        title: 'merchant payouts',
        // roles: [
        //   RoleName.Admin,
        //   RoleName.RootAdmin
        // ],
        // path: WebRoutes.MerchantPayouts,
        icon: ICONS.invoice,
        children: null
      },
      {
        ...routes[WebRoutes.Consumers.Index],
        title: 'consumers',
        // roles: [
        //   RoleName.Admin,
        //   RoleName.RootAdmin
        // ],
        // path: WebRoutes.Consumers.Index,
        icon: ICONS.ecommerce,
        children: [
          {
            ...routes[WebRoutes.Consumers.List],
            title: 'All Consumers',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.Consumers.List
          },
          {
            ...routes[WebRoutes.Consumers.Active],
            title: 'Active',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.Consumers.Active
          },
          {
            ...routes[WebRoutes.Consumers.Blacklisted],
            title: 'Blacklisted',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.Consumers.Blacklisted
          },
          {
            ...routes[WebRoutes.Consumers.WhiteListed],
            title: 'Whitelist Import History',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.Consumers.WhiteListed
          },
          {
            ...routes[WebRoutes.Consumers.ImportHistory.Index],
            title: 'Bulk KYC imports',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.Consumers.ImportHistory.Index
          },
        ]
      },
      {
        ...routes[WebRoutes.Users],
        title: 'users',
        // roles: [
        //   RoleName.Admin,
        //   RoleName.RootAdmin
        // ],
        // path: WebRoutes.Users,
        icon: ICONS.user,
        children: null
      },
      {
        ...routes[WebRoutes.QueryBuilder.Index],
        title: 'query builder',
        // roles: [
        //   RoleName.Admin,
        //   RoleName.RootAdmin
        // ],
        // path: WebRoutes.QueryBuilder.Index,
        icon: ICONS.folder,
        children: [
          {
            ...routes[WebRoutes.QueryBuilder.EsTransactions],
            title: 'Es-Transactions',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.QueryBuilder.EsTransactions
          },
          {
            ...routes[WebRoutes.QueryBuilder.EsMerchantPayoutFiles],
            title: 'Es-MerchantsPayoutFiles',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.QueryBuilder.EsMerchantPayoutFiles
          }
        ]
      },
      {
        ...routes[WebRoutes.Setup.Index],
        title: 'setup',
        // roles: [
        //   RoleName.Admin,
        //   RoleName.RootAdmin
        // ],
        // path: WebRoutes.Setup.Index,
        icon: ICONS.menuItem,
        children: [
          {
            ...routes[WebRoutes.Setup.PaymentMethodSetup],
            title: 'Payment Methods',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.Setup.PaymentMethodSetup
          },
          {
            ...routes[WebRoutes.Setup.GeneralSetup],
            title: 'General Setups',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.Setup.GeneralSetup
          },
          {
            ...routes[WebRoutes.Setup.WhatsAppMessaging.Index],
            title: 'WhatsApp Messaging'
          }
        ]
      },
      {
        ...routes[WebRoutes.OpenBanking.Index],
        title: 'open banking',
        // roles: [
        //   RoleName.Admin,
        //   RoleName.RootAdmin
        // ],
        // path: WebRoutes.OpenBanking.Index,
        icon: ICONS.banking,
        children: [
          {
            ...routes[WebRoutes.OpenBanking.BankingSDK],
            title: 'Banking SDK Connectors',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.OpenBanking.BankingSDK
          },
          {
            ...routes[WebRoutes.OpenBanking.BankingSDKRecipients],
            title: 'Open Banking Recipients',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.OpenBanking.BankingSDKRecipients
          },
          {
            ...routes[WebRoutes.OpenBanking.BankingSDKConnectorsRecipientsPivots],
            title: 'Banking SDK Connectors Recipients Pivots',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.OpenBanking.BankingSDKConnectorsRecipientsPivots,
          },
          {
            ...routes[WebRoutes.OpenBanking.IbanXS],
            title: 'Iban XS',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.OpenBanking.IbanXS
          },
          {
            ...routes[WebRoutes.OpenBanking.IbanXSBanksRecipientsPivots],
            title: 'Iban XS Banks Recipients Pivots',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.OpenBanking.IbanXSBanksRecipientsPivots
          },
          {
            ...routes[WebRoutes.OpenBanking.IbanXSBanksCountriesPivots],
            title: 'Iban XS Banks Countries Pivots',
            // roles: [
            //   RoleName.Admin,
            //   RoleName.RootAdmin
            // ],
            // path: WebRoutes.OpenBanking.IbanXSBanksCountriesPivots
          }
        ]
      },
      {
        ...routes[WebRoutes.Onboarding.Index],
        title: 'Onboarding',
        icon: ICONS.external,
        children: [
          {
            ...routes[WebRoutes.Onboarding.Applications.Index],
            title: 'Applications'
          },
          {
            ...routes[WebRoutes.Onboarding.Applications.ECommerce],
            title: 'E-Commerce'
          },
          {
            ...routes[WebRoutes.Onboarding.Applications.HighRisk],
            title: 'High-Risk'
          }
        ]
      }
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  /*{
    subheader: 'management',
    items: [
      // USER
      {
        title: 'user',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        children: [
          { title: 'profile', path: PATH_DASHBOARD.user.profile },
          { title: 'cards', path: PATH_DASHBOARD.user.cards },
          { title: 'list', path: PATH_DASHBOARD.user.list },
          { title: 'create', path: PATH_DASHBOARD.user.new },
          { title: 'edit', path: PATH_DASHBOARD.user.demoEdit },
          { title: 'account', path: PATH_DASHBOARD.user.account },
        ],
      },

      // E-COMMERCE
      {
        title: 'ecommerce',
        path: PATH_DASHBOARD.eCommerce.root,
        icon: ICONS.cart,
        children: [
          { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
          { title: 'product', path: PATH_DASHBOARD.eCommerce.demoView },
          { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
          { title: 'create', path: PATH_DASHBOARD.eCommerce.new },
          { title: 'edit', path: PATH_DASHBOARD.eCommerce.demoEdit },
          { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
        ],
      },

      // INVOICE
      {
        title: 'invoice',
        path: PATH_DASHBOARD.invoice.root,
        icon: ICONS.invoice,
        children: [
          { title: 'list', path: PATH_DASHBOARD.invoice.list },
          { title: 'details', path: PATH_DASHBOARD.invoice.demoView },
          { title: 'create', path: PATH_DASHBOARD.invoice.new },
          { title: 'edit', path: PATH_DASHBOARD.invoice.demoEdit },
        ],
      },

      // BLOG
      {
        title: 'blog',
        path: PATH_DASHBOARD.blog.root,
        icon: ICONS.blog,
        children: [
          { title: 'posts', path: PATH_DASHBOARD.blog.posts },
          { title: 'post', path: PATH_DASHBOARD.blog.demoView },
          { title: 'create', path: PATH_DASHBOARD.blog.new },
        ],
      },
      {
        title: 'File manager',
        path: PATH_DASHBOARD.fileManager,
        icon: ICONS.folder,
      },
    ],
  },

  // APP
  // ----------------------------------------------------------------------
  {
    subheader: 'app',
    items: [
      {
        title: 'mail',
        path: PATH_DASHBOARD.mail.root,
        icon: ICONS.mail,
        info: <Label color="error">+32</Label>,
      },
      {
        title: 'chat',
        path: PATH_DASHBOARD.chat.root,
        icon: ICONS.chat,
      },
      {
        title: 'calendar',
        path: PATH_DASHBOARD.calendar,
        icon: ICONS.calendar,
      },
      {
        title: 'kanban',
        path: PATH_DASHBOARD.kanban,
        icon: ICONS.kanban,
      },
    ],
  },

  // DEMO MENU STATES
  {
    subheader: 'Other cases',
    items: [
      {
        // default roles : All roles can see this entry.
        // roles: ['user'] Only users can see this item.
        // roles: ['admin'] Only admin can see this item.
        // roles: ['admin', 'manager'] Only admin/manager can see this item.
        // Reference from 'src/guards/RoleBasedGuard'.
        title: 'item_by_roles',
        path: PATH_DASHBOARD.permissionDenied,
        icon: ICONS.lock,
        roles: ['admin'],
        caption: 'only_admin_can_see_this_item',
      },
      {
        title: 'menu_level',
        path: '#/dashboard/menu_level',
        icon: ICONS.menuItem,
        children: [
          {
            title: 'menu_level_2a',
            path: '#/dashboard/menu_level/menu_level_2a',
          },
          {
            title: 'menu_level_2b',
            path: '#/dashboard/menu_level/menu_level_2b',
            children: [
              {
                title: 'menu_level_3a',
                path: '#/dashboard/menu_level/menu_level_2b/menu_level_3a',
              },
              {
                title: 'menu_level_3b',
                path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b',
                children: [
                  {
                    title: 'menu_level_4a',
                    path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b/menu_level_4a',
                  },
                  {
                    title: 'menu_level_4b',
                    path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b/menu_level_4b',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        title: 'item_disabled',
        path: '#disabled',
        icon: ICONS.disabled,
        disabled: true,
      },

      {
        title: 'item_label',
        path: '#label',
        icon: ICONS.label,
        info: (
          <Label color="info" startIcon={<Iconify icon="eva:email-fill" />}>
            NEW
          </Label>
        ),
      },
      {
        title: 'item_caption',
        path: '#caption',
        icon: ICONS.menuItem,
        caption:
          'Quisque malesuada placerat nisl. In hac habitasse platea dictumst. Cras id dui. Pellentesque commodo eros a enim. Morbi mollis tellus ac sapien.',
      },
      {
        title: 'item_external_link',
        path: 'https://www.google.com/',
        icon: ICONS.external,
      },
      {
        title: 'blank',
        path: PATH_DASHBOARD.blank,
        icon: ICONS.blank,
      },
    ],
  },*/
];

export default navConfig;
